<template>
  <div>
    <div class="container-custom">
      <div class="row" v-if="(allsettings.length > 0 && !loadingRemSettings && !loadingStatus)">
        <div class="col-2 menustyle">
          <div class="row">
            <div class="col-8" style="padding-left: 0;">
              <div class="headerTitleStyle">Messaging</div>
            </div>
            <div class="col-4 setbtn">
              <b-button
                v-if="currAdmin.role <= 1"
                class="settingsIconStyle"
                variant="outline-primary"
                v-b-modal.modal-rem-settings
              >
                <b-icon-gear></b-icon-gear>
              </b-button>
            </div>
          </div>

          <div class="row" style="margin-top: 20px;"></div>
          <div
            class="row scrollStylingBlue addscrll"
            v-bind:style="{ height: windowHeight-136 + 'px' }"
          >
            <div class="col-12 nopadd">
              <div class="row">
                <div class="col-12 nopadd headerTitleStyle2">Active Campaigns</div>
              </div>
              <div class="row">
                <div class="col-12 nopadd">
                  <RemMenu
                    v-for="campaign in campaigns.all"
                    :sets="allsettings.filter(el => el.category == campaign && el.isActive == true && !el.notApproved)"
                    v-on:menuchange="SelectedMenuChanged"
                    :isGSelected="currentSet.msId"
                    :key="campaign"
                  />
                </div>
              </div>
              <div
                class="row"
                v-if="allsettings.filter(el => el.isActive == false).length > 0"
                style="margin-top:30px;"
              >
                <div class="col-12 nopadd">
                  <div class="row">
                    <div class="col-12 nopadd headerTitleStyle2">Finished Campaigns</div>
                  </div>
                  <div class="row">
                    <div class="col-12 nopadd">
                      <RemMenu
                        v-for="campaign in campaigns.all"
                        :sets="allsettings.filter(el => el.category == campaign && el.isActive == false)"
                        :key="campaign"
                        v-on:menuchange="SelectedMenuChanged"
                        :isGSelected="currentSet.msId"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-10 nopadd" v-if="currentSet.sent != null">
          <div class="row">
            <div
              class="col-5 SlMenuTitleStyle"
            >{{selectedMenuTitle}} {{exeTime != '' && !currentSet.sent ? 'for ' + exeTime : ''}}</div>
            <div class="col-2" v-if="!wdth1250"></div>
            <div
              :class="[wdth1250 ? 'col-4' : 'col-3', 'flp-date-changer']"
              style="text-align: right; margin-top: 5px;"
            >
              <b-form-datepicker
                id="showtime-picker"
                :min="minMaxDatePicker().min"
                :max="minMaxDatePicker().max"
                v-model="showDate"
                class="mb-2 fontSizingTableDate"
              ></b-form-datepicker>
            </div>
            <div :class="[wdth1250 ? 'col-3' : 'col-2']" style="margin-top:5px;">
              <b-form-input
                v-model="searchValue"
                placeholder="Search By Cust-No"
                v-on:keyup.enter="remsToShow.length == 0 ? SearchUserInDb() : ''"
              ></b-form-input>
            </div>
          </div>
          <div class="row" v-if="exeTimeErr != '' && remsToShow.length > 0 && !currentSet.sent">
            <div
              class="col-12"
              style="color: darkred; font-size: 22px;padding: 10px; font-weight: bold;"
            >Note: Reminders won't be sent! {{exeTimeErr}}</div>
          </div>
          <div
            class="row addscrll scrollStyling2 tableFontSize tableScrollHorizontal"
            v-if="!dataloading && remsToShow.length > 0"
            v-bind:style="{ height: windowHeight- (exeTimeErr != '' ? 185 : 137) + 'px'}"
          >
            <div class="col-12">
              <b-table
                striped
                responsive
                :items="remsToShow"
                :fields="tablefieldsForm()"
                :sort-by.sync="sortTableBy"
                :sort-desc.sync="sortTableDesc"
                :filter="searchValue"
                :filter-included-fields="['custNo', 'phone', 'vin']"
                show-empty
                :tbody-tr-class="rowClass"
                @filtered="onTableFiltered"
                @row-clicked="item=>$set(item, '_showDetails', currentSet.sent ? !item._showDetails : false)"
                @head-clicked="SortIfRepCol"
              >
                <template v-if="currentSet.category == 'parts'" #cell(status)="row">
                  <b-dropdown
                    size="sm"
                    variant="outline-success"
                    :id="'prts-' + row.item.custNo"
                    :text="row.item.status"
                  >
                    <!-- class="m-md-2" -->
                    <b-dropdown-item
                      v-for="(prt, pIndx) in row.item.parts"
                      :key="prt.partName + pIndx"
                    >{{prt.partName}} - {{prt.status}}</b-dropdown-item>
                  </b-dropdown>
                </template>
                <template #cell(phone)="row">
                  <b-button
                    v-if="row.item.phone != ''"
                    @click="PhoneEditModal(row.item, row.index)"
                    size="sm"
                    class="mr-1"
                    variant="outline-primary"
                    style="border: 0;"
                  >{{row.item.phone}}</b-button>
                  <b-button
                    v-if="row.item.phone == ''"
                    @click="PhoneEditModal(row.item, row.index)"
                    size="sm"
                    class="mr-1"
                    variant="outline-primary"
                    style="font-size: 12px;"
                  >Add phone</b-button>
                </template>
                <template #cell(edit)="row">
                  <b-button
                    v-if="!currentSet.sent"
                    @click="MessagingAllowedModal(row.item, row.index)"
                    size="sm"
                    class="mr-1 contactAllowed-button"
                    variant="outline-primary"
                  >
                    <b-icon-check
                      variant="success"
                      font-scale="2"
                      v-if="!currentSet.sent && row.item.allowed"
                    ></b-icon-check>
                    {{!currentSet.sent && !row.item.allowed ? 'Off' : ''}}
                  </b-button>

                  <b-icon-check
                    variant="success"
                    font-scale="2"
                    v-if="currentSet.sent && row.item.reply_received"
                  ></b-icon-check>
                </template>
                <template slot="row-details" slot-scope="row">
                  <b-card>
                    <div class="row" style="text-align:left;">
                      <div class="col-2 m-color nopadd" style="font-weight: bold">
                        <p
                          class="nopadd mb--0"
                        >{{row.item.sent_status != 'sent' ? 'Message was not sent:' : 'Reminder message sent:'}}</p>
                        <p
                          class="nopadd collapse-msg-date-style mb--0"
                          v-if="row.item.sent_time != 'skipped' && row.item.sent_time != 'failed' && row.item.sent_time != 'undelivered'"
                        >{{row.item.sent_time}}</p>
                      </div>
                      <div
                        class="col-7 nopadd"
                      >{{row.item.sent_status != 'sent' && row.item.sent_status != 'delivered' ? row.item.ignore_reason : row.item.sent_msg}}</div>
                      <div class="col-1"></div>
                      <div
                        class="col-2"
                        style="text-align: right;"
                        v-if="row.item.reply_received && row.item.reply_ssId"
                      >
                        <b-button
                          v-if="valid(row.item.reply_ssId)"
                          v-b-modal="'modalViewChatRems' + row.item.reply_ssId.substring(0,7)"
                          variant="outline-primary"
                          @click="sRemSelected = row.item"
                        >View Chat</b-button>
                      </div>
                    </div>
                  </b-card>
                </template>
              </b-table>
            </div>

            <div class="col-12" v-if="showSearchAllOffer">
              Would you like to search all records for user with {{searchValue.length == 10 ? 'phone number' : 'customer No'}} {{searchValue}}?
              <b-button
                @click="SearchUserInDb()"
                class="mr-1"
                variant="outline-primary"
              >Search all Records</b-button>
            </div>
          </div>
          <div class="row" v-if="remsToShow.length == 0">
            <div
              class="col-10 notSelectedStyle"
              style="margin-top:10%;"
              v-if="!dataloading"
            >No data found</div>
            <div style="margin:auto;" v-if="dataloading">
              <b-spinner variant="primary" label="Spinning" style="margin-top: 100px;"></b-spinner>
            </div>
          </div>
        </div>

        <div class="row-9 notSelectedStyle" v-else>Select Campaign to display</div>
      </div>

      <div v-if="loadingStatus || (allsettings.length == 0 && loadingRemSettings)">
        <b-spinner variant="primary" label="Spinning" style="margin-top: 100px;"></b-spinner>
      </div>

      <!-- Ending note -->

      <b-modal
        :id="'editusr-phone-modal-' + editUserModData.custNo"
        @hide="editUserModData= new Object()"
        ref="editPhoneModal"
        title="Edit Phone Number"
        @ok="CheckPhoneAndSave(editUserModData)"
        ok-title="Save"
        cancel-title="Cancel"
        size="lg"
      >
        <div class="row">
          <div
            class="col-12 m-color mtt5"
            style="font-size: 20px;"
          >Phone Number for Customer #{{editUserModData.custNo}}</div>
        </div>
        <div class="row">
          <div class="col-12">
            <b-form-input v-model="editUserModData.phone" placeholder="Enter Phone number"></b-form-input>
          </div>
        </div>
      </b-modal>

      <b-modal
        :id="'editusr-msgAllowed-modal-' + editUserModData.custNo"
        @hide="editUserModData= new Object()"
        ref="editMessagingAllowed"
        title="Contact Allowed"
        @ok="CheckMessagingAllowedAndSave(editUserModData)"
        ok-title="Save"
        cancel-title="Cancel"
        size="lg"
      >
        <div class="row">
          <div class="col-12 m-color mtt5" style="font-size: 20px;">
            <b-form-checkbox
              id="checkbox-msgAllowed"
              size="lg"
              v-model="editUserModData.allowed"
            >Customer #{{editUserModData.custNo}} {{editUserModData.name}} is {{editUserModData.allowed ? 'allowed' : 'not allowed'}} to receive a reminder</b-form-checkbox>
          </div>
        </div>
      </b-modal>

      <b-modal
        :id="'editusr-modal-' + editUserModData.custNo"
        @hide="editUserModData= new Object()"
        ref="editUserModal"
        title="Edit User"
        @ok="CheckUserEdit(editUserModData)"
        ok-title="Save"
        cancel-title="Cancel"
        size="lg"
      >
        <div class="row">
          <div
            class="col-12 m-color mtt5"
            style="font-size: 20px;"
          >Customer #{{editUserModData.custNo}} {{editUserModData.name}} is scheduled to receive a reminder</div>
        </div>
        <div class="row">
          <div class="col-6" style="margin-top:25px; border-right: 1px solid #266db3">
            <div class="row" v-for="vkey in editvehkeys" :key="vkey">
              <div class="col-4 nopadd mtt5 vertcenter">{{vkey}}:</div>
              <div class="col-7 nopadd mtt5">
                <b-form-input v-model="editUserModData[vkey]"></b-form-input>
              </div>
            </div>
          </div>
          <div class="col-6" style="margin-top:25px;">
            <div class="row" v-for="vkey in editschedkeys" :key="vkey">
              <div
                class="col-4 nopadd mtt5 vertcenter"
              >{{vkey == 'dateX' ? currentSet.triggerName : vkey}}:</div>
              <div class="col-7 nopadd mtt5">
                <b-form-datepicker
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  locale="en"
                  v-if="vkey=='dateX'"
                  v-model="editUserModData[vkey]"
                ></b-form-datepicker>

                <b-form-input v-else v-model="editUserModData[vkey]"></b-form-input>
              </div>
            </div>
          </div>
        </div>
      </b-modal>

      <b-modal
        id="modal-rem-settings"
        title="Settings"
        ref="modal-rem-settings"
        @ok="SetRemSettings()"
        @show="LoadSettings()"
        ok-title="Apply"
        size="xl"
      >
        <div v-if="loadingRemSettings">
          <b-spinner variant="primary" label="Spinning" style="margin-top: 100px;"></b-spinner>
        </div>

        <!-- <div > -->

        <div class="row" v-if="!loadingRemSettings && allsettings.length > 0">
          <div class="col-3" style="border-right: 1px solid lightblue">
            <div class="row">
              <div class="col-12 nopadd">
                <b-nav vertical pills>
                  <b-nav-item
                    v-for="setTab in campaigns.active"
                    :key="'settingTab-' + setTab"
                    @click="remType = setTab"
                    :active="remType == setTab"
                  >{{setTab.substring(0,1).toUpperCase() + setTab.substring(1)}}</b-nav-item>
                </b-nav>
              </div>
            </div>
            <div class="row addCategoryBtn">
              <div class="col-12" style="text-align: right">
                <b-button
                  style="width:100%"
                  type="button"
                  variant="outline-primary"
                  size="sm"
                  v-b-modal.newCategoryAdd
                >Add Campaign</b-button>
              </div>
            </div>
          </div>
          <div class="col-9">
            <RemSettingTab
              :sets="allsettings.filter(el => el.isActive && el.category == remType)"
              :wparams="wordParams"
              v-on:settingsChanged="$set(rem_settings_changed, $event.msId, $event)"
              v-on:addMsSetting="AddNewMsgSetting($event)"
              v-on:removeSetting="RemoveSetting($event)"
              v-on:removeCategoryUsr="RemoveCategoryUsrs($event)"
              :key="'rem-' + remType"
            />
          </div>
        </div>
      </b-modal>

      <b-modal
        id="newCategoryAdd"
        title="Name Category"
        @ok="AddNewCategory()"
        @show="dataAssigned = [];csvData = [];csvNotLoaded = true;"
        @hide="newCategoryTitle = ''"
        :ok-disabled="newCategoryTitle == '' || newCategoryErr != '' || csvBtnDisable == true"
        size="lg"
      >
        <p class="mt-2">Enter this Category title, please</p>
        <p>(e.g. "Marketing 2")</p>
        <b-form-input type="text" v-model="newCategoryTitle" />
        <div class="row" style="margin-top: 7px;" v-if="newCategoryErr != ''">
          <div class="col-12" style="color: darkred;">{{newCategoryErr}}</div>
        </div>
        <div class="row" style="margin-top: 15px;">
          <div class="col-12">
            <CsvProcess
              v-on:dataAssigned="dataAssigned = $event"
              v-on:csvData="csvData = $event"
              v-on:csvNotLoaded="csvBtnDisable = $event"
            />
          </div>
        </div>
      </b-modal>
      <b-modal
        id="loadCSV"
        title="Update CSV"
        @ok="UpdateCsvUsers()"
        @show="dataAssigned = []; csvData = []; csvBtnDisable = true;"
        :ok-disabled="csvBtnDisable == true"
        size="lg"
      >
        <p class="mt-2">Load updated CSV for this campaign</p>

        <div class="row" style="margin-top: 15px;">
          <div class="col-12">
            <CsvProcess
              v-on:dataAssigned="dataAssigned = $event"
              v-on:csvData="csvData = $event"
              v-on:csvNotLoaded="csvBtnDisable = $event"
            />
          </div>
        </div>
      </b-modal>
      <b-modal
        v-if="sRemSelected && valid(sRemSelected.reply_ssId)"
        size="xl"
        :id="'modalViewChatRems' + sRemSelected.reply_ssId.substring(0,7)"
        header-class="headerModalClass"
        centered
        hide-footer
        :title="`${sRemSelected.name} (${sRemSelected.custNo})`"
      >
        <viewChatWindow
          :ssId="sRemSelected.reply_ssId"
          :colId="'ch-hist-' + sRemSelected.reply_ssId.substring(0,6)"
        />
      </b-modal>
    </div>
  </div>
</template>


<script >
import firebase from "firebase/app";
import RemSettingTab from "./ReminderComponents/Settings/RemSettingTab.vue";
import viewChatWindow from "./additionalComponents/viewChatWindow.vue";

import RemMenu from "./ReminderComponents/RemMenuElement.vue";
import CsvProcess from "./ReminderComponents/Settings/CsvProcess.vue";
import axios from "axios";

export default {
  name: "ReminderPanel",
  components: {
    RemMenu,
    RemSettingTab,
    CsvProcess,
    viewChatWindow
  },
  props: {
    currAdmin: Object,
    unsentList: Array
  },
  data() {
    return {
      loadingStatus: false,

      selectedMenuTitle: "",
      remsToShow: [],
      dataloading: false,
      remType: "appointment",
      loadingRemSettings: false,

      rem_settings_changed: {},

      csvData: [],
      csvBtnDisable: true,
      dataAssigned: [],

      newCategoryTitle: "",
      disableCustDateBtn: true,
      searchValue: "",

      locs: {
        londonderrydodge: {
          name: "Londonderry Dodge",
          sname: "LDC"
        },
        northsidemitsubishi: { name: "NorthSide Mitsubishi", sname: "NSM" },
        lanissan: { name: "LaNissan", sname: "LAN" },
        lamazda: { name: "LaMazda", sname: "LAM" },
        northsidenissan: { name: "NorthSide Nissan", sname: "NSN" },
        rivercityhyundai: { name: "Rivercity Hyundai", sname: "RCH" },
        sherwoodkia: { name: "Sherwood Kia", sname: "SPK" },
        sherwoodnissan: { name: "Sherwood Nissan", sname: "SPN" }
      },
      exeTime: "",
      exeTimeErr: "",
      showDate: "",
      windowHeight: 400,
      windowWidth: 1475,
      sortTableBy: "custNo",
      sortTableDesc: false,

      totalTableRows: 1,
      currentTablePage: 1,
      editUserModData: {},
      editvehkeys: ["make", "model", "year", "kms"],
      editschedkeys: ["phone", "dateX", "CR_OP_DESC"],
      showSearchAllOffer: false,
      sRemSelected: {},

      isTodaySelected: false,
      sentRemsToShow: [],
      schedRemsToShow: [],
      sentLoaded: false,
      schedLoaded: false,

      allsettings: [],
      currentSet: {},
      wordParams: {}
    };
  },

  created() {
    this.LoadSettings();

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();
  },
  watch: {
    showDate: function(val) {
      if (this.valid(val)) {
        this.remsToShow = [];
        this.searchValue = "";

        this.sentRemsToShow = [];
        this.schedRemsToShow = [];
        this.sentLoaded = false;
        this.schedLoaded = false;

        this.isTodaySelected =
          new Date(`${this.showDate} 12:00:00 PM`).toLocaleDateString("en-US", {
            timeZone: "America/Edmonton"
          }) ==
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Edmonton"
          });
        this.loadReminders();
      }
    },

    searchValue: function() {
      this.showSearchAllOffer = false;
    }
  },

  computed: {
    wdth1250() {
      return this.windowWidth < 1300;
    },
    newCategoryErr: function() {
      let res = "";
      if (
        this.allsettings.find(
          el => el.category == this.newCategoryTitle.toLowerCase()
        )
      ) {
        res = `This Category Name is already in use`;
      }
      return res;
    },
    campaigns: function() {
      let [arr, arr2] = [[], []];
      this.allsettings.forEach(st => {
        if (!arr.includes(st.category)) {
          arr.push(st.category);
        }
        if (st.isActive && !arr2.includes(st.category)) {
          arr2.push(st.category);
        }
      });
      return { active: arr2, all: arr };
    }
  },
  methods: {
    AddNewMsgSetting(e) {
      let nms = {
        msg_body: "Enter reminder message here",
        title: e.title,
        msId: e.msId,
        category: e.category,
        isActive: true,
        ignoreIf: {
          appointment: false,
          marketing: false,
          partsNotReady: false,
          partsReady: false
        },
        msg_pool: this.FormSettingsMsgPool(e.category),
        exec_time: [
          {
            daytype: "weekday",
            allowed: false,
            time: {
              ampm: "pm",
              hours: "1",
              minutes: "00"
            }
          },
          {
            daytype: "saturday",
            allowed: false,
            time: {
              ampm: "pm",
              hours: "1",
              minutes: "00"
            }
          },
          {
            daytype: "daysOff",
            allowed: false,
            time: {
              ampm: "pm",
              hours: "1",
              minutes: "00"
            }
          }
        ],
        ignoreReply: {
          days: "0",
          status: false
        },
        trigger: -14,
        allowed: true,
        type: "reminder",
        triggerName: e.triggerName,
        ignoreContactAllowed: false,
        ignoreScheduled: false
      };

      if (e.instantDb === true) {
        // console.log("INSTANT ADD");
        firebase
          .firestore()
          .doc(`messaging/${this.currAdmin.location}/settings/${nms.msId}`)
          .set(nms, { merge: true });
      } else {
        // console.log("NOTINSTANT ADD");
        nms["notApproved"] = true;
      }

      this.allsettings.push(nms);
      this.$set(this.rem_settings_changed, nms.msId, nms);
    },
    RemoveSetting(mId) {
      let that = this;
      if (this.valid(this.rem_settings_changed[mId])) {
        delete this.rem_settings_changed[mId];
      }
      firebase
        .firestore()
        .collection(`messaging/${this.currAdmin.location}/sent`)
        .where("msId", "==", mId)
        .limit(1)
        .get()
        .then(rss => {
          let c = 0;
          rss.forEach(() => {
            c = c + 1;
          });

          that.RemovingSetProcess(mId, c > 0);
        });
    },

    RemovingSetProcess(mId, toArchive) {
      this.remType = "marketing";

      let ix = this.allsettings.findIndex(el => el.msId == mId);

      if (toArchive) {
        if (ix > -1) {
          this.$set(this.allsettings[ix], "isActive", false);
        }
        firebase
          .firestore()
          .doc(`messaging/${this.currAdmin.location}/settings/${mId}`)
          .update({ isActive: false, allowed: false });
      } else {
        if (ix > -1) {
          this.allsettings.splice(ix, 1);
        }

        firebase
          .firestore()
          .doc(`messaging/${this.currAdmin.location}/settings/${mId}`)
          .delete();
      }
    },
    RemoveCategoryUsrs(category) {
      let that = this;
      if (this.valid(category)) {
        firebase
          .firestore()
          .doc(
            `messaging/${this.currAdmin.location}/campaignSettings/${category}`
          )
          .delete();

        firebase
          .firestore()
          .collection(`events`)
          .where("sch", "==", `${this.currAdmin.location}/${category}`)
          .limit(1)
          .get()
          .then(rss => {
            let c = 0;
            rss.forEach(() => {
              c = c + 1;
            });

            if (c > 0) {
              //remove all waiting events from db for this category
              that.SendCustomCampaignChanges("remove", category, []);
            }
          });
      }
    },
    AddCsvDataToDb(cmpName, mode) {
      let newEvents = [];
      let wordp = [];
      let folders = [
        { folder: "car", keys: ["make", "model", "year", "kms", "carId"] }
      ];
      for (let i = 0; i < this.csvData.length; i++) {
        let row = this.csvData[i];
        let obj = new Object();
        this.dataAssigned.forEach(a => {
          if (i == 0) {
            wordp.push({
              folder: this.valid(a.folder)
                ? a.folder
                : folders.find(el => el.keys.includes(a.key))
                ? folders.find(el => el.keys.includes(a.key)).folder
                : "",
              rep: a.key,
              tag: row[a.value]
            });
          } else {
            if (this.valid(a.folder)) {
              if (!this.valid(obj[a.folder])) {
                obj[a.folder] = new Object();
              }
              obj[a.folder][a.key] = row[a.value];
            } else {
              obj[a.key] = row[a.value];
            }
          }
        });
        if (i != 0) {
          newEvents.push(obj);
        }
      }

      wordp.push({ folder: "", rep: "", tag: "ServiceLink" });

      this.wordParams[cmpName] = [];
      wordp.forEach(w => {
        this.wordParams[cmpName].push(w.tag);
      });

      firebase
        .firestore()
        .doc(`messaging/${this.currAdmin.location}/campaignSettings/${cmpName}`)
        .set({ word_params: wordp });

      this.SendCustomCampaignChanges(mode, cmpName, newEvents);
      // console.log(newEvents[0]);
    },

    SendCustomCampaignChanges(mode, cmpName, evs) {
      this.loadingRemSettings = true;

      let that = this;
      axios
        .post(
          `https://us-central1-car-appointment-fsqahl.cloudfunctions.net/messagingcampaign/loadcsv/${mode}`,
          {
            category: cmpName.toLowerCase(),
            location: this.currAdmin.location,
            events: evs
          },
          {
            headers: {
              auth: "e8ePMr1K1AfENfJuJK9QXmSqyiKgm2fm",
              "Content-Type": "application/json"
            }
          }
        )
        .then(rs => {
          that.loadingRemSettings = false;
          alert(
            `${
              rs.data.result == "success"
                ? "Data was loaded:)"
                : "Something went wrong... " + (rs.data.details || "")
            }`
          );
        })
        .catch(err => {
          console.log(err);
          that.loadingRemSettings = false;
          alert("Oops.. Something went wrong..");
        });
    },
    UpdateCsvUsers() {
      this.AddCsvDataToDb(this.remType, "update");

      let trn = this.dataAssigned.find(el => el.key == "dateX");
      let tr = "";
      if (this.valid(trn)) {
        tr = this.csvData[0][trn.value];
      }

      let starr = this.allsettings.filter(el => el.category == this.remType);

      if (starr.length > 0 && starr[0].triggerName != `${tr} Date`) {
        for (let i in starr) {
          this.$set(starr[i], "triggerName", `${tr} Date`);
          let st = starr[i];
          firebase
            .firestore()
            .doc(`messaging/${this.currAdmin.location}/settings/${st.msId}`)
            .update({ triggerName: `${tr} Date` });
        }
      }
    },
    AddNewCategory() {
      this.newCategoryTitle = this.newCategoryTitle
        .trim()
        .split(` `)
        .join("_")
        .toLowerCase();
      this.AddCsvDataToDb(this.newCategoryTitle, "add");

      let trn = this.dataAssigned.find(el => el.key == "dateX");
      let tr = "";
      if (this.valid(trn)) {
        tr = this.csvData[0][trn.value];
      }

      this.AddNewMsgSetting({
        title: `${this.newCategoryTitle}_1`,
        msId: this.uigen(),
        category: this.newCategoryTitle.toLowerCase(),
        triggerName: `${tr} Date`,
        instantDb: true
      });
    },

    uigen() {
      return (
        "t" +
        Math.random()
          .toString(36)
          .substr(2, 9) +
        `${Date.now()}`
      );
    },

    minMaxDatePicker() {
      const now = new Date(
        new Date().toLocaleDateString("en-US", {
          timeZone: "America/Edmonton"
        })
      );
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

      return {
        value: "",
        min: this.currentSet.sent ? "" : today,
        max: this.currentSet.sent ? today : ""
      };
    },
    SortIfRepCol(col) {
      if (this.currentSet.sent && col == "edit") {
        this.remsToShow.sort(function(a, b) {
          return a === b ? 0 : a ? -1 : 1;
        });
      }
    },
    expandRow(row) {
      row._showDetails = !row._showDetails;
    },
    tablefieldsForm() {
      let tb = [
        { key: "custNo", sortable: true },
        { key: "name", sortable: true },
        { key: "make", sortable: true },
        { key: "model", sortable: true },
        { key: "year", sortable: true },
        { key: "vin", sortable: true },
        { key: "phone", sortable: true },
        { key: "dateX", label: this.currentSet.triggerName, sortable: true }
      ];

      if (this.currentSet.category == "appointment") {
        tb.unshift({ key: "apptNo", sortable: true });
        tb.push({ key: "Appt_Time", sortable: true });
      } else if (this.currentSet.category == "parts") {
        tb.unshift({ key: "SO#", sortable: true });
        tb.push({ key: "status", label: "Parts Ready" });
      } else if (this.currentSet.category == "marketing") {
        tb.push(
          { key: "kms", sortable: true },
          { key: "dateX", label: "CR_CF_DATE", sortable: true }
          // { key: "CR_CF_DATE", sortable: true }
        );
      }

      if (this.currentSet.sent) {
        tb.push(
          { key: "sent_time", label: "Sent on", sortable: true },
          { key: "edit", label: "Replied", sortable: true }
        );
      } else {
        tb.push(
          { key: "scheduled", label: "Reminder Scheduled", sortable: true },
          { key: "edit", label: "Contact Allowed" }
        );
      }

      if (this.currentSet.category == "appointment" && !this.currentSet.sent) {
        tb.push({ key: "SVC-OP-DESC", sortable: true });
      }
      return tb;
    },

    PhoneEditModal(item, index) {
      index;
      this.editUserModData = Object.assign({}, item);
      this.$refs["editPhoneModal"].show();
    },

    MessagingAllowedModal(item, index) {
      index;
      this.editUserModData = Object.assign({}, item);
      this.$refs["editMessagingAllowed"].show();
    },

    EditUser(item, index) {
      index;

      this.editUserModData = Object.assign({}, item);
      this.editUserModData.dateX = this.FormatTime(
        new Date(`${this.editUserModData.dateX} 12:00:00 PM MST`)
      );

      this.$refs["editUserModal"].show();
    },
    SearchUserInDb() {
      this.showDate = "";
      this.remsToShow = [];
      this.showSearchAllOffer = false;
      this.dataloading = true;

      let that = this;
      firebase
        .firestore()
        .collection(
          `${
            this.currentSet.sent
              ? "messaging/" + this.currAdmin.location + "/sent"
              : "events"
          }`
        )
        .where(
          `${this.currentSet.sent ? "msId" : "sch"}`,
          "==",
          `${
            this.currentSet.sent
              ? this.currentSet.msId
              : this.currAdmin.location + "/" + this.currentSet.category
          }`
        )
        .where(
          `${this.searchValue.length == 10 ? "user_phone" : "userId"}`,
          `${this.searchValue.length == 10 ? "array_contains" : "=="}`,
          this.searchValue.length != 10
            ? this.UserIdToLoc(this.searchValue)
            : this.searchValue
        )
        .get()
        .then(rss => {
          rss.forEach(rs => {
            let rr = rs.data();
            rr["docId"] = rs.id;
            that.remsToShow.push(this.FormTableItem(rr));
          });
          that.dataloading = false;
        });
    },
    onTableFiltered(filteredItems) {
      if (filteredItems.length == 0) {
        this.showSearchAllOffer = true;
      }

      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalTableRows = filteredItems.length;
      this.currentTablePage = 1;
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (!this.valid(item.phone) || !item.allowed) return "table-danger";
    },
    execTime() {
      let dd = new Date(`${this.showDate} 12:00:00 pm MST`).getDay();

      let mstime = this.currentSet.exec_time[dd == 0 ? 2 : dd == 6 ? 1 : 0];

      this.exeTime =
        mstime.allowed &&
        this.valid(mstime.time.ampm) &&
        this.valid(mstime.time.hours) &&
        this.valid(mstime.time.minutes)
          ? `${mstime.time.hours}:${mstime.time.minutes} ${mstime.time.ampm}`
          : "";

      this.exeTimeErr =
        this.exeTime == "" || !this.currentSet.allowed
          ? !mstime.allowed || !this.currentSet.allowed
            ? "Reminder is turned off in Settings"
            : "Check execution time in Settings"
          : "";
    },
    SelectedMenuChanged: function(e) {
      if (this.valid(e.sent) && this.valid(e.msId)) {
        this.currentSet = this.allsettings.find(el => el.msId == e.msId);
        this.currentSet["sent"] = e.sent;

        this.remsToShow = [];
        this.schedRemsToShow = [];
        this.sentRemsToShow = [];

        let tmpDate = this.showDate;
        this.showDate = "";

        let todayDate = new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Edmonton"
          })
        );
        this.showDate = this.FormatTime(todayDate);
        if (this.showDate === tmpDate) {
          this.loadReminders();
        }

        this.selectedMenuTitle = `${this.currentSet.category
          .substring(0, 1)
          .toUpperCase()}${this.currentSet.category.substring(1)} -> ${
          this.currentSet.title
        } -> ${e.sent ? "Sent" : e.sent === false ? "Scheduled" : ""}`;
      }
    },
    FormatTime(t) {
      if (this.valid(t)) {
        return `${t.getFullYear()}-${
          t.getMonth() + 1 < 10 ? "0" + (t.getMonth() + 1) : t.getMonth() + 1
        }-${t.getDate() < 10 ? "0" + t.getDate() : t.getDate()}`;
      } else {
        return "";
      }
    },
    loadReminders() {
      if (this.valid(this.showDate)) {
        if (!this.currentSet.sent) {
          this.execTime();
        }

        this.dataloading = true;

        this.loadRemindersProcess(this.currentSet.sent);
        if (this.isTodaySelected && !this.currentSet.sent) {
          this.loadRemindersProcess(true);
        }
      }
    },

    loadRemindersProcess(showSent) {
      let nnw = {
        start: Date.parse(`${this.showDate} 12:00:02 AM MDT`),
        end: Date.parse(`${this.showDate} 11:59:58 PM MDT`)
      };

      let that = this;
      firebase
        .firestore()
        .collection(
          `${
            showSent
              ? "messaging/" + this.currAdmin.location + "/sent"
              : "events"
          }`
        )
        .where(
          `${showSent ? "msId" : "sch"}`,
          "==",
          `${
            showSent
              ? this.currentSet.msId
              : this.currAdmin.location + "/" + this.currentSet.category
          }`
        )
        .where(
          `${showSent ? "sent_time" : "xdate"}`,
          ">=",
          nnw.start -
            (showSent ? 0 : this.currentSet.trigger * 24 * 60 * 60 * 1000)
        )
        .where(
          `${showSent ? "sent_time" : "xdate"}`,
          "<=",
          nnw.end -
            (showSent ? 0 : this.currentSet.trigger * 24 * 60 * 60 * 1000)
        )
        .get()
        .then(rss => {
          rss.forEach(rs => {
            let rr = rs.data();
            rr["docId"] = rs.id;
            if (showSent) {
              that.sentRemsToShow.push(rr);
            } else {
              that.schedRemsToShow.push(rr);
            }
          });

          that.LoadingFinish(showSent);
        });
    },

    LoadingFinish(snt) {
      let loading = false;
      if (snt) {
        this.sentLoaded = true;
      } else {
        this.schedLoaded = true;
      }

      if (!this.currentSet.sent && this.isTodaySelected) {
        if (this.schedLoaded && this.sentLoaded) {
          // let tmpcancelled = this.schedRemsToShow.filter(
          //   el =>
          //     !this.sentRemsToShow.find(
          //       elem => elem.eventId == el.eventId && elem.status == "cancelled"
          //     )
          // );

          this.schedRemsToShow = this.schedRemsToShow.filter(
            el => !this.sentRemsToShow.find(elem => elem.eventId == el.eventId)
          );

          // tmpcancelled.forEach(e => {
          //   e["isCancelled"] = true;
          //   this.schedRemsToShow.unshift(e);
          // });
        } else {
          loading = true;
        }
      }

      if (loading === false) {
        let tmp = Array.from(
          this.currentSet.sent ? this.sentRemsToShow : this.schedRemsToShow
        );
        tmp.forEach(el => {
          this.remsToShow.push(this.FormTableItem(el));
        });

        this.sentLoaded = false;
        this.schedLoaded = false;
      }
      this.dataloading = loading;
    },

    FormTableItem(rr) {
      let sched = rr.xdate + this.currentSet.trigger * 24 * 60 * 60 * 1000;

      let remObj = {
        docId: rr.docId,
        custNo: rr.userId,
        name: `${rr.user_name} ${rr.user_lastname}`,
        make: rr.car.make,
        model: rr.car.model,
        year: rr.car.year,
        vin:
          rr.car.carId.includes("new_") || rr.car.carId.includes("noId")
            ? ""
            : rr.car.carId,
        kms: this.valid(rr.kms) ? rr.kms : rr.car.kms,
        phone: this.currentSet.sent ? rr.phone : rr.cell
      };

      remObj["dateX"] = new Date(rr.xdate).toLocaleDateString("en-US", {
        timeZone: "America/Edmonton"
      });

      if (this.currentSet.category == "appointment") {
        remObj["apptNo"] = rr.eventId;
        remObj["Appt_Time"] = rr.appointment_details.time;
        remObj["SVC-OP-DESC"] = rr.appointment_details
          ? rr.appointment_details.user_request
          : "";
        // remObj["Appt_Scheduled"] = new Date(rr.xdate).toLocaleString("en-US", {
        //   timeZone: "America/Edmonton"
        // });
      } else if (this.currentSet.category == "parts") {
        remObj["SO#"] = rr.eventId;
        remObj["status"] = rr.status;
        remObj["parts"] = rr.parts;
      } else if (this.currentSet.category == "marketing") {
        // remObj["kms"] = this.valid(rr.kms) ? rr.kms : rr.car.kms;
        remObj["CR_OP_DESC"] = rr.appointment_details
          ? rr.appointment_details.reason_desc
          : "";
        // remObj["CR_CF_DATE"] = remObj["dateX"];
        // remObj["CR_CF_DATE"] = new Date(rr.xdate).toLocaleDateString("en-US", {
        //   timeZone: "America/Edmonton"
        // });
      }

      if (this.currentSet.sent) {
        remObj["sent_status"] = rr.sent_status;
        remObj["reply_received"] = rr.reply_received;
        remObj["reply_ssId"] = rr.reply_ssId || "";
        remObj["sent_msg"] = rr.sent_msg;
        remObj["sent_time"] =
          rr.sent_status == "skipped"
            ? "skipped"
            : rr.sent_status == "failed" || rr.sent_status == "undelivered"
            ? rr.sent_status
            : new Date(rr.sent_time).toLocaleString("en-US", {
                timeZone: "America/Edmonton"
              });
        remObj["allowed"] =
          rr.sent_status == "sent" || rr.sent_status == "delivered";
        remObj["ignore_reason"] = this.valid(rr.ignore_reason)
          ? rr.ignore_reason
          : rr.sent_status == "failed" || rr.sent_status == "undelivered"
          ? `At SMS sending step Twilio returned status "${rr.sent_status}"`
          : "";
      } else {
        remObj["scheduled"] = new Date(sched).toLocaleDateString("en-US", {
          timeZone: "America/Edmonton"
        });
        remObj["allowed"] = rr.messagingAllowed;
      }

      return remObj;
    },

    CheckPhoneAndSave(eusr) {
      eusr.phone =
        eusr.phone.substring(0, 1) == "+"
          ? eusr.phone.substring(1)
          : eusr.phone;
      eusr.phone =
        eusr.phone.substring(0, 1) == "1"
          ? eusr.phone.substring(1)
          : eusr.phone;

      eusr.phone = eusr.phone.replace(/[^0-9]/g, "");

      let usrIndex = this.remsToShow.findIndex(el => el.custNo == eusr.custNo);
      if (usrIndex > -1) {
        let usr = this.remsToShow[usrIndex];
        if (usr.phone != eusr.phone) {
          this.remsToShow[usrIndex].phone = eusr.phone;
          firebase
            .firestore()
            .doc(`events/${usr.docId}`)
            .set({ cell: eusr.phone }, { merge: true });

          firebase
            .firestore()
            .doc(`users/${usr.custNo}`)
            .get()
            .then(rs => {
              let r = rs.data();
              if (this.valid(r.phones_on_file)) {
                if (!r.phones_on_file.find(el => el == eusr.phone)) {
                  r.phones_on_file.unshift(eusr.phone);
                  firebase
                    .firestore()
                    .doc(`users/${usr.custNo}`)
                    .set({ phones_on_file: r.phones_on_file }, { merge: true });
                }
              }
            });
        }
      }
    },

    CheckMessagingAllowedAndSave(eusr) {
      let usrIndex = this.remsToShow.findIndex(el => el.custNo == eusr.custNo);
      if (usrIndex > -1) {
        let usr = this.remsToShow[usrIndex];
        if (usr.allowed != eusr.allowed) {
          this.remsToShow[usrIndex].allowed = eusr.allowed;
          firebase
            .firestore()
            .doc(`events/${usr.docId}`)
            .set({ messagingAllowed: eusr.allowed }, { merge: true });
        }
      }
    },

    CheckUserEdit(eusr) {
      let usrIndex = this.remsToShow.findIndex(el => el.custNo == eusr.custNo);
      if (usrIndex > -1) {
        let usr = this.remsToShow[usrIndex];

        eusr.dateX = new Date(
          `${eusr.dateX} 12:00:00 PM MST`
        ).toLocaleDateString("en-US", {
          timeZone: "America/Edmonton"
        });

        for (let key in eusr) {
          if (eusr[key] !== usr[key]) {
            if (usr.phone !== eusr.phone) {
              firebase
                .firestore()
                .doc(`users/${usr.custNo}`)
                .get()
                .then(usrSnap => {
                  let u = usrSnap.data();
                  if (this.valid(u)) {
                    if (!u.phones_on_file.includes(eusr.phone)) {
                      u.phones_on_file.unshift(eusr.phone);
                    }

                    firebase
                      .firestore()
                      .doc(`users/${usr.custNo}`)
                      .update({
                        phones_on_file: u.phones_on_file,
                        phone: eusr.phone
                      });
                  }
                });
            }

            let crcf = Date.parse(`${eusr.dateX} 12:00:00 PM MST`);
            eusr.scheduled = new Date(
              crcf + this.currentSet.trigger * 24 * 60 * 60 * 1000
            ).toLocaleDateString("en-US", {
              timeZone: "America/Edmonton"
            });

            // let alwd = usr.isCancelled || true;
            // if (alwd != eusr.allowed){
            //   if (eusr.allowed === false){
            //     firebase
            //   .firestore()
            //   .doc(`messaging/${this.currAdmin.location}/sent/${}`)
            //   } else if (this.valid(usr.isCancelled))
            // }

            firebase
              .firestore()
              .doc(`events/${usr.docId}`)
              .get()
              .then(rs => {
                let r = rs.data();
                // let ex = r.exReminder || [];
                // let exIndex = ex.findIndex(el => el == this.currentSet.msId);
                // if (exIndex > -1 && eusr.allowed) {
                //   ex.splice(exIndex, 1);
                // } else if (exIndex == -1 && !eusr.allowed) {
                //   ex.push(this.currentSet.msId);
                // }

                r.appointment_details.date = new Date(crcf).toLocaleDateString(
                  "en-US",
                  {
                    timeZone: "America/Edmonton"
                  }
                );
                r.appointment_details.reason = eusr.CR_OP_DESC || "";
                r.xdate = crcf;
                r.car.make = eusr.make;
                r.car.model = eusr.model;
                r.car.year = eusr.year;
                r.car.kms = eusr.kms;
                r.user_phone.unshift(eusr.phone);
                // r["exReminder"] = ex;

                this.$set(this.remsToShow, usrIndex, eusr);

                firebase
                  .firestore()
                  .doc(`events/${usr.docId}`)
                  .set(r, { merge: true });
              });

            break;
          }
        }
      }
    },

    getWindowHeight() {
      this.windowHeight = document.documentElement.clientHeight;
      this.windowWidth = document.documentElement.clientWidth;
    },

    LoadSettings() {
      this.remType = "marketing";
      this.rem_settings_changed = new Object();
      this.allsettings = []; //new
      this.loadingRemSettings = true;

      let that = this;
      firebase
        .firestore()
        .collection(`messaging/${this.currAdmin.location}/settings`)
        .get()
        .then(r => {
          r.forEach(rs => {
            let rd = rs.data();
            if (!this.valid(that.wordParams[rd.category])) {
              that.wordParams[rd.category] = [];
              firebase
                .firestore()
                .doc(
                  `messaging/${this.currAdmin.location}/campaignSettings/${rd.category}`
                )
                .get()
                .then(wps => {
                  let wp = wps.data();
                  if (
                    this.valid(wp) &&
                    this.valid(wp.word_params) &&
                    wp.word_params.length > 0
                  ) {
                    wp.word_params.forEach(w => {
                      that.wordParams[rd.category].push(w.tag);
                    });
                  }
                });
            }

            that.allsettings.push(rd); //new
          });

          this.loadingRemSettings = false;
        });
    },

    SetRemSettings() {
      for (let ky in this.rem_settings_changed) {
        let mss = this.rem_settings_changed[ky];
        if (mss.notApproved === true) {
          delete mss.notApproved;
        }

        firebase
          .firestore()
          .doc(`messaging/${this.currAdmin.location}/settings/${mss.msId}`)
          .set(mss, { merge: true });

        let i = this.allsettings.findIndex(el => el.msId == mss.msId);
        if (i > -1) {
          this.$set(this.allsettings, i, mss);
        }
      }
    },

    dbSet: function(data) {
      data.ref = data.ref.replace("{{loc}}", this.currAdmin.location);
      firebase
        .database()
        .ref(data.ref)
        .update(data.value);
    },

    FormatDateToMMDDYYY(t) {
      let tt = new Date(t).toString().split("GMT")[0];
      let tta = tt.split(" ");
      return `${tta[1]} ${tta[2]} ${tta[3]}`;
    },

    FormSettingsMsgPool(category) {
      let poolarray = [
        {
          enabled: true,
          trigger: "main",
          ignore: false,
          msg_body: ""
        },
        {
          enabled: false,
          trigger: "appointment",
          ignore: false,
          msg_body: ""
        },
        {
          enabled: false,
          trigger: "marketing",
          ignore: false,
          msg_body: ""
        },
        {
          enabled: false,
          trigger: "partsReady",
          ignore: false,
          msg_body: ""
        },
        {
          enabled: false,
          trigger: "partsNotReady",
          ignore: false,
          msg_body: ""
        }
      ];

      if (category == "parts") {
        poolarray.splice(3, 2);
      } else if (category == "appointment") {
        poolarray.splice(1, 1);
      } else if (category == "marketing") {
        poolarray.splice(2, 1);
      }

      return poolarray;
    },

    UserIdToLoc(id) {
      return `${
        this.currAdmin.location != "londonderrydodge"
          ? this.locs[this.currAdmin.location].sname + "-"
          : ""
      }${id}`;
    },
    valid(val) {
      return val != undefined && val != null && val !== "";
    }
  }
};
</script>

<style>
.addCategoryBtn {
  position: absolute;
  bottom: 0;
  width: 90%;
}
.collapse-msg-date-style {
  font-weight: 100;
  font-size: 12px;
}
tr:focus {
  outline: 0;
}
.vertcenter {
  align-self: center;
}
.mtt5 {
  margin-top: 5px;
}
.addscrll {
  overflow-x: hidden;
  overflow-y: scroll;
}
.notSelectedStyle {
  margin: auto;
  font-size: 28px;
}
.SlMenuTitleStyle {
  line-height: 36px;
  font-size: 18px;
  text-align: left;
  font-weight: bold;
}
.nopadd {
  padding: 0;
}
.settingsIconStyle {
  color: #fff;
  border-color: #fff;
  /* color: #266db3; */
  /* border: 0; */
}
.settingsIconStyle:hover {
  /* color: rgb(49, 57, 76); */
  /* background-color: transparent; */
  background-color: #266db3;

  border: 1px solid #266db3;
}
.setbtn {
  padding-right: 5px;
  text-align: right;
  padding-top: 5px;
}
.headerTitleStyle2 {
  font-size: 18px;
  /* color: steelblue; */
  color: #fff;
  line-height: 44px;

  text-align: left;
  font-weight: bold;
}

.headerTitleStyle {
  /* color: #266db3; */
  font-size: 18px;
  color: #fff;
  line-height: 44px;
  font-weight: bold;
  /* font-size: 24px; */
  text-align: left;
  font-weight: bold;
}
.menustyle {
  /* border-right: 1px solid lightgray; */
  padding-right: 0;
  /* background-color: #e5ecf8; */
  background-color: rgb(49, 57, 76);
}
.border-menu {
  border-right: 1px solid lightgray;
}
.headerStyleFlUp {
  height: 44px;
  /* background-color: #b9b3b35d; */
  border-bottom: 1px solid black;
  max-width: 1200px;
  margin: auto;
}

.headerStyleInnerFlUp {
  height: 44px;
  /* background-color: #b9b3b35d; */
  margin-top: 20px;
  cursor: pointer;
  /* border-bottom: 1px solid black; */
}

.mb--0 {
  margin-bottom: 0;
}

.headerStyleFlpInTxtMain {
  line-height: 44px;
  text-align: left;
  font-weight: bold;
  font-size: 22px;
}

.headerStyleFlpInTxtMain select {
  border: 0px;
  line-height: 44px;
  text-align: left;
  font-weight: bold;
  font-size: 22px;
  padding-top: 0;
}

.flp-date-changer select {
  /* background: #6c757d; */
  color: #266db3;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #266db3;
  width: 100%;
  font-weight: bold;
  cursor: pointer;
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 0px 15px;
  height: 1.8rem;
  margin-top: 3px;
}
.mb-5px {
  margin-bottom: 5px;
}
.padd-0 {
  padding: 0;
}
.no-border {
  border: 0;
  border-radius: 0;
  /* border-bottom: 1px solid; */
}
.aval-from-style {
  padding-left: 0px;
  padding-right: 3px;
  border-right: 1px solid lightgrey;
}

.aval-till-style {
  padding-left: 7px;
  padding-right: 0;
}

.m-color {
  color: #266db3;
}

.collapseHover:hover {
  background-color: aliceblue;
}
.autoOverflow-flp {
  height: 87vh;
  width: 100%;
  overflow-y: auto;
  resize: vertical;
}
.align-right {
  text-align: right;
}
.flp-msgbox-style {
  text-align: left;
  margin-bottom: 1rem;
}
.searchWordStyle {
  padding-top: 7px;
  text-align: right;
  font-size: 18px;
  color: dimgrey;
}
.container-custom {
  width: 100%;
}

.tableFontSize {
  font-size: 15px;
}

.align-main-swithers {
  text-align: left;
  align-self: center;
}

.tableScrollHorizontal {
  overflow-x: scroll;
  flex-flow: column;
}
.table-responsive {
  width: fit-content;
}

.contactAllowed-button {
  border: 0;
}

.contactAllowed-button:hover {
  border: 1px solid #266db3;
  background-color: transparent;
  color: darkred;
}

@media (min-width: 1306px) and (max-width: 1440px) {
  .tableFontSize {
    font-size: 13px;
  }
  .table-responsive {
    width: fit-content;
  }
}

@media (min-width: 1251px) and (max-width: 1305px) {
  .tableFontSize {
    font-size: 12px;
  }
  .fontSizingTableDate {
    font-size: 13px;
  }
  .table-responsive {
    width: fit-content;
  }
}

@media (min-width: 600px) and (max-width: 1251px) {
  .tableFontSize {
    font-size: 12px;
  }
  /* .tableScrollHorizontal {
    overflow-x: scroll;
    flex-flow: column;
  } */
  .table-responsive {
    /* width: fit-content; */
    width: 1250px;
  }
  .SlMenuTitleStyle {
    font-size: 16px;
  }
  .fontSizingTableDate {
    font-size: 12px;
  }
}

.scrollStylingBlue::-webkit-scrollbar {
  width: 5px;
  background-color: #3a4d91;
}

.scrollStylingBlue::-webkit-scrollbar-thumb {
  background-color: #3a4d91;
}

.scrollStylingBlue::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.3); */
  background-color: #e5ecf8;
}

.scrollStyling2::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.3); */
  background-color: #ffffff;
}

.scrollStyling2::-webkit-scrollbar {
  width: 8px;
  background-color: #ffffff;
}

.scrollStyling2::-webkit-scrollbar-thumb {
  background-color: rgb(187, 187, 187);
}
/deep/ .tgf-disable-input {
  color: #6c757d;
  background-color: #e9ecef;
}

/deep/ .tagify {
  min-height: 86px;
}
</style>